import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["startOn", "endOn", "vehicle", "dailyRate", "status"]
  static values = {
    url: String,
    currentVehicleId: String,
    selectPrompt: String,
    chooseDates: String,
    loading: String,
    noneAvailable: String
  }

  connect() {
    this.setStatus(this.chooseDatesValue)
    this.refreshIfReady()
  }

  disconnect() {
    window.clearTimeout(this.refreshTimer)
    this.abortController?.abort()
  }

  datesChanged() {
    window.clearTimeout(this.refreshTimer)
    this.refreshTimer = window.setTimeout(() => this.refreshIfReady(), 200)
  }

  vehicleChanged() {
    const option = this.vehicleTarget.selectedOptions[0]
    if (option?.dataset.dailyRate !== undefined) {
      this.dailyRateTarget.value = option.dataset.dailyRate
    }
  }

  submitted(event) {
    if (!event.detail.success) return

    const responseUrl = event.detail.fetchResponse?.response?.url
    Turbo.visit(responseUrl || window.location.href, { action: "replace" })
  }

  async refreshIfReady() {
    const startOn = this.startOnTarget.value.trim()
    const endOn = this.endOnTarget.value.trim()

    if (!startOn || !endOn) {
      this.replaceOptions([])
      this.setStatus(this.chooseDatesValue)
      return
    }

    this.abortController?.abort()
    this.abortController = new AbortController()
    this.setStatus(this.loadingValue)

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("start_on", startOn)
    url.searchParams.set("end_on", endOn)

    try {
      const response = await fetch(url, {
        headers: { Accept: "application/json" },
        signal: this.abortController.signal
      })
      const data = await response.json()
      this.replaceOptions(response.ok ? data.vehicles : [])
      this.setStatus(data.vehicles?.length ? "" : this.noneAvailableValue)
    } catch (error) {
      if (error.name !== "AbortError") {
        this.replaceOptions([])
        this.setStatus(this.noneAvailableValue)
      }
    }
  }

  replaceOptions(vehicles) {
    const selectedId = this.vehicleTarget.value || this.currentVehicleIdValue
    this.vehicleTarget.replaceChildren(new Option(this.selectPromptValue, ""))

    vehicles.forEach((vehicle) => {
      const option = new Option(vehicle.label, vehicle.id)
      option.dataset.dailyRate = vehicle.daily_rate
      option.selected = String(vehicle.id) === String(selectedId)
      this.vehicleTarget.add(option)
    })

    this.vehicleTarget.disabled = vehicles.length === 0
  }

  setStatus(message) {
    this.statusTarget.textContent = message
    this.statusTarget.classList.toggle("d-none", !message)
  }
}
